<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p10-1.jpg" width="100%" alt="蓝鲨 Robor 座充、直充、汽车充多场景充电"></div>
          <div class="text t10">
            <div class="t10_1 fs_content">座充</div>
            <div class="fs_tiny">家用電池座安全快充</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p10-2.jpg" width="100%" alt="蓝鲨 Robor 座充、直充、汽车充多场景充电"></div>
          <div class="text t10">
            <div class="t10_1 fs_content">直充</div>
            <div class="fs_tiny">社區停車棚便捷直充</div>
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide>
        <div class="swiper">
          <div class="pic"><img src="/static/img/p10-3.jpg" width="100%" alt="蓝鲨 Robor 座充、直充、汽车充多场景充电"></div>
          <div class="text t10">
            <div class="t10_1 fs_content">汽车充</div>
            <div class="fs_tiny">汽车充电桩随停随充</div>
          </div>
        </div>
      </swiper-slide> -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
  data(){
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,swiperSlide
  },
  computed: {
    swiper(){
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination{
  bottom: 5vw !important;
}
.t10{
  bottom: 8vw;
  text-align: center;
  width: 100%;
  .t10_1{
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_tw/swiper10.vue